// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphText.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphText.tsx");
  import.meta.hot.lastModified = "1732036225887.9626";
}
// REMIX HMR END

import clsx from "clsx";
import htmlParser from "~/components/helpers/htmlParser";
import Heading from "../Heading";
const variants = {
  primary: "",
  secondary: "items-center",
  tertiary: "border rounded-4xl border-secondary-200 p-6 items-center"
};
export default function Text({
  titleOptional,
  subtitle,
  text,
  variant,
  background
}) {
  const textColor = background === "dark" ? "!text-neutral-100" : undefined;
  const textParsed = htmlParser({
    html: text.processed || "",
    theme: background || "light"
  });
  const subtitleTag = titleOptional ? "h3" : "h2";
  return <section className={clsx("w-full flex flex-col", variants[variant])}>
      {titleOptional && <Heading tag="h2" className={textColor}>
          {titleOptional}
        </Heading>}
      {subtitle && <Heading tag={subtitleTag} className={textColor}>
          {subtitle}
        </Heading>}
      <div className={clsx(background === "dark" ? "wysiwyg-dark" : "wysiwyg")}>
        <div>{textParsed}</div>
      </div>
    </section>;
}
_c = Text;
var _c;
$RefreshReg$(_c, "Text");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;